__turbopack_context__.v({
  "content": "ItineraryCardContent-module__SAlRVq__content",
});
